module.exports = __webpack_public_path__ + "img/carposina-sasakii.583e55c1.jpg";